module.exports = __webpack_public_path__ + "static/desktop/img/templates-2.83aec671.png";